import script from "./sectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./sectionCard.vue?vue&type=script&setup=true&lang=js"

import "./sectionCard.vue?vue&type=style&index=0&id=402c336b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402c336b"]])

export default __exports__